import { connect } from 'react-redux';
// types
import { Dispatch } from 'types/dispatch';
import { State } from './root.reducers';

import Root from './root.component';

import { Actions as LoginActions } from 'modules/login';
import { Actions as LanguageProviderActions } from 'modules/language-provider';
import { goToLoginPage } from '../modules/login/login.actions';

const { logOut } = LoginActions;
const { fetchLanguage } = LanguageProviderActions;

const mapStateToProps = (state: State) => ({
    config: state.config,
    loginSession: state.login.loginSession,
    activeLanguageCode: state.language.activeLanguageCode
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logOut: () => {
        dispatch(logOut());
    },
    fetchLanguage: (languageCode: string): void => {
        dispatch(fetchLanguage(languageCode));
    },
    goToLoginPage: (): void => {
        dispatch(goToLoginPage());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);
